/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutShortcutOrderingPathParams = NonNullable<operations['putShortcutOrdering']['parameters']['path']>;

export type PutShortcutOrderingRequestBody = OperationRequestBodyContent<operations['putShortcutOrdering']>;

export interface Input extends PutShortcutOrderingPathParams {
  apiVersion?: string;
  body: PutShortcutOrderingRequestBody;
}

export async function putShortcutOrdering(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/internal/profile/shortcuts/{projectKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
